/**
 * Email Event API Service
 * Handles all backend communication related to SystemEmailEvent
 */

import axiosInstance from "./axiosInstance";

const BASE = "/admin/email";

/**
 * Fetch paginated list of email events
 */
export const fetchEmailEvents = (params) => {
  return axiosInstance.get(`${BASE}/events/`, { params });
};

/**
 * Fetch single email event with recipients
 */
export const fetchEmailEventDetail = (eventId, params) => {
  return axiosInstance.get(`${BASE}/events/${eventId}/`, { params });
};

/**
 * Resend a single failed recipient
 */
export const resendRecipient = (recipientId) => {
   return axiosInstance.post(
    `/email-recipients/${recipientId}/resend/`
  );
};

/**
 * Resend all failed recipients for event
 */
export const resendFailedForEvent = (eventId) => {
    return axiosInstance.post(
    `/email-events/${eventId}/resend-failed/`
  );
};

export const checkTaskStatus = async (taskId) => {
  const response = await axiosInstance.get(
    `/celery-task-status/${taskId}/`
  );
  return response.data;
};

export const deleteEmailEvent = async (eventId) => {
  return axiosInstance.delete(
    `/email-events/${eventId}/delete/`
  );
};